// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Effect from "../Effect/index.js";
import * as Ouroboros_Models_Core_Ok from "../Ouroboros.Models.Core.Ok/index.js";
import * as Ouroboros_Services_FFI_IO from "../Ouroboros.Services.FFI.IO/index.js";
var sequence1 = /* #__PURE__ */ Data_Traversable.sequence(Data_Traversable.traversableArray)(Effect.applicativeEffect);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var map2 = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect);
var sequence = function (ios) {
    return sequence1(map1(function (v) {
        return v;
    })(ios));
};
var run = Ouroboros_Services_FFI_IO.run;
var pure = function (value) {
    return pure1(value);
};
var map = function (f) {
    return function (v) {
        return map2(f)(v);
    };
};
var sequenceOk = function (ios) {
    return map(function (v) {
        return Ouroboros_Models_Core_Ok.ok;
    })(sequence(ios));
};
var chain = function (f) {
    return function (v) {
        return function __do() {
            var value = v();
            var v1 = f(value);
            return v1();
        };
    };
};
var tap = function (f) {
    return function (ioValue) {
        return chain(function (value) {
            return map(function (v) {
                return value;
            })(f(value));
        })(ioValue);
    };
};
export {
    pure,
    run,
    map,
    chain,
    tap,
    sequence,
    sequenceOk
};
//# sourceMappingURL=index.js.map
